import React, { ReactNode } from 'react';
import SearchableSelect from '../SearchableSelect/SearchableSelect';
import { UserOutlineIcon } from '../../icons/inputIcons';
import { IClientsItem } from '../../../modules/API/Defaults/models/customers';

interface Props {
    customers: IClientsItem[];
    value: IClientsItem | null;
    onSelect: (customer: IClientsItem | null) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    allowClear?: boolean;
    clearLabel?: string;
    leadingIcon?: ReactNode | null;
    className?: string;
}

const CustomerSelector: React.FC<Props> = ({
    customers,
    value,
    onSelect,
    placeholder = 'בחר לקוח',
    disabled,
    readOnly,
    allowClear,
    clearLabel = 'הכל',
    leadingIcon,
    className,
}) => (
    <SearchableSelect<IClientsItem>
        items={customers}
        value={value}
        onSelect={onSelect}
        getKey={(c) => c.CustomerID}
        getLabel={(c) => (c.Customer_Name ?? '').trim()}
        getSearchText={(c) => c.Customer_Name ?? ''}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        allowClear={allowClear}
        clearLabel={clearLabel}
        leadingIcon={leadingIcon === undefined ? <UserOutlineIcon /> : leadingIcon}
        className={className}
        emptyLabel='אין לקוחות מתאימים'
    />
);

export default CustomerSelector;
